<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="bg-gray-900 dark print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center p-4 pl-6 w-full">
            <!-- Logo -->
            <div class="flex justify-center items-center">
                <!-- <img class="w-8" src="images/logo/logo.svg"> -->
                <!-- <img class="w-8" src=" https://andrew.miniplanner.dev/Content/Images/BE-FE-DA-70-77-52-EF-83-D5-47-E5-BE-42-13-BF-5D-A8-75-02-D4.png"> -->
                <!-- <img src="images/logo/logo.png"> -->
                <a [routerLink]="['/']">
                    <img class="w-8" src="images/logo/BE-FE-DA-70-77-52-EF-83-D5-47-E5-BE-42-13-BF-5D-A8-75-02-D4.png">
                </a>
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto">
                <notifications></notifications>
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        @if(user){
            <div class="flex flex-col items-center p-4 w-full">
                <div class="relative w-24 h-24">
                    <mat-icon
                        class="icon-size-24"
                        [svgIcon]="'heroicons_solid:user-circle'"
                    ></mat-icon>
                </div>
                <div class="flex flex-col justify-center items-center mt-6 w-full">
                    <div class="overflow-hidden w-full font-medium leading-normal text-center whitespace-nowrap text-ellipsis">
                        {{ user.firstName }} {{ user.surname }}
                    </div>
                    <div class="overflow-hidden mt-0.5 w-full font-medium leading-normal text-center whitespace-nowrap text-secondary text-ellipsis text-md">
                        {{ user.email }}
                    </div>
                </div>
            </div>
        }
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div
            class="flex justify-center items-center pr-6 pl-2 mt-2 mb-4 h-16 flex-0 opacity-12"
        >
            <!-- <img class="max-w-36" src="images/logo/logo-text-on-dark.svg"> -->

            <img class="max-w-36" src="images/logo/logo.png">
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="flex relative items-center px-4 w-full h-16 shadow bg-card z-49 flex-0 dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')" aria-label="Toggle navigation menu">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <languages></languages>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>
            <!-- <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()"
                aria-label="Toggle chat">
                <mat-icon
                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                ></mat-icon>
            </button> -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!-- <div class="flex relative justify-start items-center px-4 w-full h-14 border-t flex-0 md:px-6 z-49 bg-card dark:bg-transparent print:hidden">
        <a href="https://www.dante.co.uk">
            <span class="font-medium text-secondary">Powered by Dante &copy; {{currentYear}}</span>
        </a>
    </div> -->
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
